// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"205":"581e3bc2b3870785","208":"15adf32932c1f953","287":"11a8329a81d4aebf","556":"c754b6ebda86a466","864":"4b7057134b0ef695"}[chunkId] + ".js";
};